export default /* @ngInject */ function(configProvider, stripeConfigProvider) {
    stripeConfigProvider.key = configProvider.stripeKey;
    stripeConfigProvider.supportedBrands = [
        'Visa',
        'American Express',
        'MasterCard'
    ];
}



// WEBPACK FOOTER //
// ./payments/config/stripe.js